import { Dialog } from "@shared/ui/Dialog";
import { Loader } from "@shared/ui/Loader";
import { QuizResponse } from "@platform/types/quiz.types";
import { QuizQuestionSet } from "../QuizQuestionSet/QuizQuestionSet";
import { useQuizProps } from "./useQuizProps";

type Props = {
  onDone: () => void;
  onClose: () => void;
  isOpen: boolean;
  isLoading: boolean;
  quizResponseId: number;
  quiz: QuizResponse | undefined;
};

export function QuizDialog({
  onDone,
  onClose,
  isOpen,
  quizResponseId,
  quiz,
  isLoading,
}: Props) {
  const {
    activeQuestionSet,
    buttonLabel,
    filterQuestionSet,
    handleNextQuestionObject,
    handlePreviousQuestionObject,
    isSubmitting,
    title,
    description,
    formData,
    stepIndex,
    totalSteps,
  } = useQuizProps({
    quizResponseId,
    quiz: quiz || ({} as QuizResponse),
    resetIndexKey: isOpen,
    onCompleteQuiz: onDone,
  });

  if (isLoading || !quiz) {
    return (
      <Dialog
        isOpen={isOpen}
        title="Loading"
        description="Please wait while we load the form."
        onClose={onClose}
        className="flex flex-col flex-1 p-0 md:px-0"
        isWithActions={false}
        size="4xl"
      >
        <Loader />
      </Dialog>
    );
  }

  return (
    <Dialog
      isOpen={isOpen}
      title={title}
      description={description}
      onClose={onClose}
      className="flex flex-col flex-1 p-0 md:px-0"
      isWithActions={false}
      size="4xl"
    >
      {isLoading ? (
        <Loader />
      ) : (
        <QuizQuestionSet
          questionSet={activeQuestionSet}
          filterQuestionSet={filterQuestionSet}
          buttonLabel={buttonLabel}
          isSubmitting={isSubmitting}
          onSubmit={handleNextQuestionObject}
          onBack={handlePreviousQuestionObject}
          defaultValues={formData}
          stepIndex={stepIndex}
          totalSteps={totalSteps}
        />
      )}
    </Dialog>
  );
}

export default QuizDialog;
